import { createDefaultTyrann } from '@apis/common';
import { staff, staffQuery } from '@models/Staff';
import * as t from 'io-ts';
import * as h from 'tyrann-io';

export const addStaffBody = t.type({
  staff_id: t.string,
  first_name: t.string,
  last_name: t.string,
  role: t.string,
  email: t.string,
  password: t.string,
  agency_id: h.omittable(t.number),
});

export type AddStaffBody = t.TypeOf<typeof addStaffBody>;

export const staffPatchBody = t.type({
  staff_id: t.string,
  first_name: t.string,
  last_name: t.string,
  role: t.string,
  agency_id: h.omittable(t.number),
});

export type StaffPatchBody = t.TypeOf<typeof staffPatchBody>;

export const addStaffQuery = t.type({
  become_member: t.boolean,
});

export type AddStaffQuery = t.TypeOf<typeof addStaffQuery>;

export const staffsApis = createDefaultTyrann({
  '/dashboard/staff/': {
    get: {
      query: staffQuery,
      response: {
        200: t.type({
          count: t.number,
          results: h.omittable(t.array(staff)),
        }),
      },
    },
    post: {
      query: addStaffQuery,
      body: addStaffBody,
      response: {
        201: staff,
        400: t.type({
          non_field_errors: h.omittable(t.array(t.string)),
        }),
      },
    },
  },
});

export const staffApis = createDefaultTyrann({
  '/dashboard/staff/{id}/': {
    get: {
      path: t.type({
        id: t.number,
      }),
      response: {
        200: staff,
      },
    },
    delete: {
      path: t.type({
        id: t.number,
      }),
      response: {
        204: t.any,
      },
    },
    patch: {
      path: t.type({
        id: t.number,
      }),
      body: staffPatchBody,
      response: {
        200: staff,
        400: t.type({
          non_field_errors: h.omittable(t.array(t.string)),
        }),
      },
    },
  },
});
